import { render, staticRenderFns } from "./DebtorIpuFilter.vue?vue&type=template&id=dd16ea88&"
import script from "./DebtorIpuFilter.vue?vue&type=script&lang=js&"
export * from "./DebtorIpuFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports